import { connect } from 'react-redux'

import { RootState } from '../../../store'
import { getAppLoading } from '../../../selectors/app'
import { getUserSessionState, getUserErrorState } from '../../../selectors/user'
import { twoFactTrigger } from '../../../actions'

import { TwoFact } from '../../../components/pages/Login/TwoFact'

const mapStateToProps = (state: RootState) => {
  return {
    loading: getAppLoading(state),
    userSession: getUserSessionState(state),
    userError: getUserErrorState(state),
    recoverSuccess: state.user.recoverSuccess,
  }
}

export default connect(mapStateToProps, { login: twoFactTrigger })(TwoFact)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Login/TwoFact.tsx